import ONGP1 from "../../interfaces/finishedProgress";
import { useContext, useState } from "react"
import { AuthContext } from "../../context/auth";
import { useNavigate } from 'react-router-dom';

interface UserRowProps {
    ongP1List: ONGP1[] // Changed to accept an array
}

export default function MktProgressTable({
    ongP1List
}: UserRowProps)

{
    const navigate = useNavigate();
    const userContext = useContext(AuthContext);
    const [expandedCard, setExpandedCard] = useState<number | null>(null);

    function back() {
        navigate('/dashboard/previewp8c')
    }

    function sendOne() {
        let token: string = "";

        if (localStorage.getItem("USER_TOKEN") !== null) 
        {
            token = localStorage.getItem("USER_TOKEN")!;
        }

        fetch(`${userContext?.api_url}/user/getFinishedMKTAll`, 
        {
            method: 'POST',
            headers: 
            {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': token
            }
        }).then(resp => 
            {
            if (resp.status >= 400) 
            {
                console.log(resp);
            } 
            else 
            {
                resp.json().then(jsonResponse => 
                {
                    console.log(resp);
                })
            }
        }).catch((err) => 
        {
            console.log(err);
        })
    }

    return(
    <div className="w-full p-4 bg-principal-3 overflow-auto">
        <div className="overflow-x-auto shadow-md rounded-lg">
            <h1 className="text-2xl md:text-3xl font-semibold text-center text-principal-2 uppercase mb-5">
                PROGRESO - MERCANTIL
            </h1>
            
            {/* Mobile view - Card format */}
            <div className="md:hidden">
                {ongP1List.map((ongP1, idx) => (
                    <div key={`mobile-card-${idx}`} className="bg-white rounded-lg shadow mb-4 p-4">
                        <div className="flex justify-between border-b pb-2 mb-2">
                            <span className="font-bold text-black">ID:</span>
                            <span className="text-black">{String(ongP1.id)}</span>
                        </div>
                        <div className="flex justify-between border-b pb-2 mb-2">
                            <span className="font-bold text-black">Nombre:</span>
                            <span className="text-black">{String(ongP1.nombre)}</span>
                        </div>
                        
                        <button 
                            className="mt-3 bg-principal-1 text-white py-2 px-4 rounded w-full"
                            onClick={() => setExpandedCard(expandedCard === idx ? null : idx)}
                        >
                            {expandedCard === idx ? 'Ocultar detalles' : 'Ver detalles'}
                        </button>

                        {expandedCard === idx && (
                            <div className="mt-4">
                                {[
                                    { num: 1, value: ongP1.finishedone },
                                    { num: 2, value: ongP1.finishedtwo },
                                    { num: 3, value: ongP1.finishedthree },
                                    { num: 4, value: ongP1.finishedfour },
                                    { num: 5, value: ongP1.finishedfive },
                                    { num: 6, value: ongP1.finishedsix },
                                    { num: 7, value: ongP1.finishedseven },
                                    { num: 8, value: ongP1.finishedeight },
                                    { num: 9, value: ongP1.finishednine },
                                    { num: 10, value: ongP1.finishedten }
                                ].map((item, index) => (
                                    <div key={index} className="flex justify-between py-1 border-b">
                                        <span className="font-medium text-black">Cuestionario {item.num}:</span>
                                        <span className={`${item.value ? 'text-green-600' : 'text-red-600'} font-medium`}>
                                            {item.value ? 'Terminado' : 'No terminado'}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            
            {/* Desktop view - Table format */}
            <div className="hidden md:block">
                <div className="overflow-x-auto">
                    <table className="table-auto w-full font-roboto border-collapse bg-white">
                        <thead className="text-xs font-semibold uppercase text-principal-2 bg-principal-1">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-center">ID</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Nombre</div>
                                </th>
                                {Array.from({length: 10}, (_, i) => (
                                    <th key={i} className="p-2">
                                        <div className="font-semibold text-center">C{i+1}</div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="text-sm divide-y divide-gray-100 text-black">
                            {ongP1List.map((ongP1, idx) => (
                                <tr key={`desktop-row-${idx}`}>
                                    <td className="p-2">
                                        <div className="font-medium text-center">{String(ongP1.id)}</div>
                                    </td>
                                    <td className="p-2">
                                        <div className="font-medium text-center">{String(ongP1.nombre)}</div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedone ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedone ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedtwo ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedtwo ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedthree ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedthree ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedfour ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedfour ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedfive ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedfive ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedsix ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedsix ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedseven ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedseven ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedeight ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedeight ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishednine ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishednine ? '✓' : '✗'}
                                        </div>
                                    </td>
                                    <td className="p-2">
                                        <div className={`font-medium text-center ${ongP1.finishedten ? 'text-green-600' : 'text-red-600'}`}>
                                            {ongP1.finishedten ? '✓' : '✗'}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    );
}